import styled from "@emotion/styled"

export const StyledAiAgent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: radial-gradient(
      circle at 4% -8%,
      rgba(99, 102, 241, 0.14) 0%,
      transparent 35%
    ),
    radial-gradient(
      circle at 98% 108%,
      rgba(14, 165, 233, 0.12) 0%,
      transparent 42%
    ),
    var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
  }

  .back-btn,
  .new-btn,
  .secondary-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 14px;
  }

  .new-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
    padding: 14px;
  }

  .page-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 26px 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  .config-alert {
    margin-bottom: 10px;
  }

  .config-chip-wrap {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .search-section {
    margin-bottom: 10px;
    padding: 14px;
    background: var(--cms-surface-secondary);
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
  }

  .search-form {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
  }

  .search-form .MuiTextField-root,
  .search-form .MuiFormControl-root {
    min-width: 170px;
  }

  .search-form .search-keyword {
    min-width: 260px;
  }

  .search-actions {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .table-container {
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-secondary);
  }

  .matching-voices {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 10px;
    margin-bottom: 10px;
  }

  .matching-voices-title {
    margin: 0 0 8px;
    font-size: 13px;
    font-weight: 700;
    color: var(--cms-text-primary);
  }

  .matching-voices-list {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .matching-voice-item {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-surface-secondary);
    padding: 6px 8px;
    font-size: 12px;
    color: var(--cms-text-primary);
  }

  .matching-voice-item .MuiButton-root {
    text-transform: none;
    border-radius: 8px;
    min-height: 30px;
    font-weight: 700;
  }

  .MuiTableContainer-root {
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .MuiTableCell-head {
    background: var(--cms-surface-muted);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .pagination-container {
    display: flex;
    justify-content: center;
    padding: 20px;
    background: var(--cms-surface-secondary);
    border-top: 1px solid var(--cms-border);
  }

  .status-badge {
    padding: 4px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    text-transform: none;
  }

  .status-active {
    background: #dcfce7;
    color: #166534;
  }

  .status-inactive {
    background: #fee2e2;
    color: #b91c1c;
  }

  .specialties-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }

  .specialty-tag {
    background: #edf4ff;
    color: #1e40af;
    padding: 2px 6px;
    border-radius: 999px;
    font-size: 11px;
    border: 1px solid #dbe7ff;
    font-weight: 700;
  }

  .action-buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .description-cell {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--cms-text-secondary);
  }

  .long-description-cell {
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .content-text-cell {
    max-width: 300px;
    max-height: 100px;
    overflow: auto;

    .MuiTypography-root {
      font-family: "Courier New", monospace;
      background-color: var(--cms-surface-muted);
      padding: 8px;
      border-radius: 4px;
      border: 1px solid var(--cms-border);
    }
  }

  .table-empty {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 18px;
  }

  .detail-shell {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
    padding: 14px;
  }

  .detail-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
  }

  .detail-toolbar .MuiButton-root {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
  }

  .knowledge-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    flex-wrap: wrap;
  }

  .knowledge-toolbar .MuiButton-root {
    text-transform: none;
    font-weight: 700;
    border-radius: 9px;
    min-height: 36px;
  }

  .knowledge-search {
    margin-bottom: 10px;
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 12px;
  }

  .upload-dropzone {
    border: 2px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 16px;
  }
`
